module.exports = __webpack_public_path__ + "img/IMG_9094.daf926f0.jpg";